import React, {useState, useEffect} from "react";
import { Col, Card, CardBody } from "reactstrap";
import PropTypes from 'prop-types';

//Simple bar
import SimpleBar from "simplebar-react";

//Import Images
import img1 from "../../assets/images/companies/img-1.png";
import img2 from "../../assets/images/companies/img-2.png";
import img3 from "../../assets/images/companies/img-3.png";
import { formatDate } from "helpers/backend_helper";
import { Link } from "react-router-dom";
import CardWelcome from "./card-welcome";

const Notifications = (props) => {

  return (
    <React.Fragment>
      <Col xl="4">
        <CardWelcome />
      </Col>
    </React.Fragment>
  );
};
Notifications.propTypes = {
  approvals: PropTypes.any,
  birthdays: PropTypes.any
};
export default Notifications;
